import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { Box, Paper, Typography, Button, useTheme } from "@mui/material";

const SignInPage = () => {
  const { instance } = useMsal();
  const theme = useTheme();

  const handleSignIn = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error("Login failed:", e);
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="95vh"
      px={2}
      sx={{
        backgroundColor: theme.palette.grey[100],
        fontFamily: theme.typography.fontFamily,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 2,
          textAlign: "center",
          maxWidth: 400,
          width: "100%",
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          color="text.primary"
          gutterBottom
        >
          Welcome to SDL
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 3, lineHeight: 1.6 }}
        >
          Please sign in to access the portal and tools.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          onClick={handleSignIn}
          sx={{
            py: 1.5,
            textTransform: "none",
            fontSize: "1rem",
            borderRadius: 1,
          }}
        >
          Sign In
        </Button>
      </Paper>
    </Box>
  );
};

export default SignInPage;
